import { useQuery } from '@tanstack/react-query';
import { getLatestResourceItems } from '../api/resources.member.api';
import { resourcesKeys } from './resources.keys';

/** The newest `limit` resource items, newest first (member dashboard, MYN-254). */
export function useLatestResources(limit: number) {
  return useQuery({
    queryKey: resourcesKeys.latestItems(limit),
    queryFn: () => getLatestResourceItems(limit),
  });
}
